import easyfyAxios from '@shared/easyfy.axios';

export const PostForm = (url: string, data: any, token: any) => {
  return easyfyAxios.post(url, data, token);
};
